import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';

const FixedPricingTable = ({ selectedSize, numberOfLogos, wholesaleCost, desiredMargin, totalHardCost, fee }) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch('/pricingDataFix.json')
      .then(response => response.json())
      .then(data => setData(data));
  }, []);

  const selectedData = data.find(item => item.SIZE === selectedSize);
  //const quantityMargins = [1.48, 1.45, 1.37, 1.35, 1.30];
  const quantityMargins = [1.48, 1.45, 1.43, 1.38, 1.35];
  const quantities = [50, 100, 250, 500, 1000];

  const calculatePrice = (qty) => {
    if (selectedData) {
      const decorationCost = selectedData[qty] || 0;
      const numericFee = parseFloat(fee);
      const totalHardCost = (wholesaleCost + decorationCost * numberOfLogos) * qty + numericFee;
      const hcPerItem = totalHardCost / qty;
      //const salePrice = hcPerItem * (desiredMargin || quantityMargins[quantities.indexOf(qty)]);
      return {
        totalHardCost: totalHardCost.toFixed(2),
        hcPerItem: hcPerItem.toFixed(2),
        //salePrice: salePrice.toFixed(2),
        //afterDiscount: (salePrice * 0.9).toFixed(2) // Assuming a 10% discount
      };
    }
    return {
      totalHardCost: '',
      hcPerItem: '',
      //salePrice: 'N/A',
      //afterDiscount: 'N/A'
    };
  };

  return (
    <div>
      <h3>Fixed Quantity Pricing</h3>
      <Table striped bordered hover>
        <thead>
          <tr>
            <td>Qty</td>
            <td>Hard Cost Per Item</td>
            <td>Selected Margin (Total)</td>
            <td>Selected Margin Price Per Item</td>
            <td>Discount Margin (Total)</td>
            <td>Discount Price</td>
            <td>Discount</td>
          </tr>
        </thead>
        <tbody>
          {quantities.map((qty, index) => {
            const prices = calculatePrice(qty);
            const actualMargin = prices.hcPerItem !== 'N/A' ? (prices.hcPerItem * desiredMargin * qty / prices.totalHardCost).toFixed(2) : 'N/A';
            //const discountToCustomer = prices.hcPerItem !== 'N/A' ? ((1 - (quantityMargins[index] / (prices.hcPerItem * desiredMargin * qty / prices.totalHardCost)))*100).toFixed(0) : 'N/A';
            const discountToCustomer = prices.hcPerItem !== 'N/A' ? (((actualMargin / quantityMargins[index])-1)*100).toFixed(2) : 'N/A';
            return (
              <tr key={qty}>
                <td>{qty}</td>
                <td>${prices.hcPerItem}</td>
                <td>{actualMargin} (${(prices.hcPerItem * qty * actualMargin).toFixed(2)})</td>
                <td>${(prices.hcPerItem * actualMargin ).toFixed(2)}</td>
                <td>{quantityMargins[index]} (${(prices.hcPerItem * qty * quantityMargins[index] ).toFixed(2)})</td>
                <td>${(prices.hcPerItem * quantityMargins[index] ).toFixed(2)}</td>
                <td>{discountToCustomer}%</td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </div>
  );
};

export default FixedPricingTable;
